import { combineReducers } from "redux";
import courses from "./courseReducer";
import authors from "./authorReducer";
import games from "./gameReducer";
import apiCallsInProgress from "./apiStatusReducer";

const rootReducer = combineReducers({
  games,
  courses,
  authors,
  apiCallsInProgress,
});

export default rootReducer;
